var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"images-modal","size":"xl","scrollable":"","centered":"","hide-footer":"","header-class":"lightbox-header","body-class":"lightbox-body","content-class":"lightbox-modal-content","lazy":""}},[_c('media-carousel',{attrs:{"selectedImage":_vm.selectedImage,"imageList":_vm.imageList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }